var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "katman_1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "4.7cm",
        height: "1.2cm",
        version: "1.1",
        viewBox: "0 0 133.3 33.8",
      },
    },
    [
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M53.7,0c-.9,0-1.6.3-2.2,1-.6.6-.9,1.3-.9,2.2s.3,1.6.9,2.2c.6.6,1.4.9,2.2.9s1.6-.3,2.2-.9c.6-.6.9-1.4.9-2.2s-.3-1.6-1-2.2c-.6-.6-1.3-1-2.2-1ZM81.3,7.2c-2.4,0-4.2,1-5.5,2.9-1.2-2-3-2.9-5.4-2.9s-3.5.8-4.6,2.3h0v-1.7h-5.3v18.7h5.3v-9.2c0-1.7.1-3,.3-3.7.4-1.4,1.2-2.2,2.5-2.2s2,.7,2.3,2.1c.2.6.2,1.8.2,3.5v9.5h5.3v-9.2c0-1.7.1-2.9.3-3.7.4-1.5,1.3-2.2,2.5-2.2s1.9.6,2.2,1.9c.2.7.3,1.8.3,3.3v9.8h5.3v-11.7c0-5.1-2-7.7-5.9-7.7ZM19.9.2h-5.3v7.6H0v4.5h14.5v14.2h5.3v-14.2h3.3v-4.5h-3.3V.2ZM108.7,26.6V7.8h-5.3v1.8c-1.3-1.6-3.1-2.4-5.2-2.4s-4.7,1-6.3,3.1c-1.5,1.9-2.2,4.1-2.2,6.8s.7,5,2.2,6.9c1.6,2.1,3.7,3.1,6.4,3.1s3.9-.8,5.1-2.3h0v1.7h5.3ZM102.8,20.8c-.9,1.1-2,1.7-3.3,1.7s-2.4-.6-3.2-1.7c-.8-1-1.2-2.2-1.2-3.6s.4-2.5,1.2-3.5c.9-1.1,1.9-1.7,3.2-1.7s2.4.6,3.3,1.7c.8,1,1.2,2.2,1.2,3.5s-.4,2.5-1.2,3.6ZM51.1,26.6h5.3V7.9h-5.3v18.7ZM36.2,10.1c-1.8,1.9-2.7,4.3-2.7,7.1s.9,5.1,2.7,7c1.8,1.9,4.1,2.9,6.8,2.9s3.2-.4,4.6-1.1v-5.1c-1.1,1.2-2.3,1.8-3.7,1.8s-2.7-.5-3.6-1.6c-.9-1-1.3-2.2-1.3-3.8s.4-2.7,1.2-3.8c.9-1.2,2.1-1.8,3.5-1.8s2.7.6,3.9,1.8v-5.1c-1.3-.8-2.7-1.2-4.3-1.2-2.8,0-5.1,1-7,2.9ZM25.4,26.6h5.3V7.9h-5.3v18.7ZM28.1,0c-.9,0-1.6.3-2.2,1-.6.6-.9,1.3-.9,2.2s.3,1.6.9,2.2c.6.6,1.4.9,2.2.9s1.6-.3,2.2-.9c.6-.6.9-1.4.9-2.2s-.3-1.6-1-2.2c-.6-.6-1.3-1-2.2-1ZM133.3,2.3h-6.2l-6.3,9.3-2.8-3.6h-6.3l6.2,7.9-12.3,18h6.3l9.4-13.7,5,6.4h6.3l-8.4-10.7,9.2-13.5Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }